import { createContext, useContext, useState } from 'react';

interface PrescriptionModalCtx {
  isPrescriptionModalOpen: boolean;
  setIsPrescriptionModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isPrescriptionSucceeded: boolean;
  setIsPrescriptionSucceeded: React.Dispatch<React.SetStateAction<boolean>>;
}

const PrescriptionModal = createContext({} as PrescriptionModalCtx);

export const PrescriptionModalProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isPrescriptionModalOpen, setIsPrescriptionModalOpen] = useState(false);
  const [isPrescriptionSucceeded, setIsPrescriptionSucceeded] = useState(false);

  return (
    <PrescriptionModal.Provider
      value={{
        isPrescriptionModalOpen,
        setIsPrescriptionModalOpen,
        isPrescriptionSucceeded,
        setIsPrescriptionSucceeded,
      }}
    >
      {children}
    </PrescriptionModal.Provider>
  );
};

export const usePrescriptionModal = () => {
  const context = useContext(PrescriptionModal);

  if (!context) {
    throw new Error(
      'usePrescriptionModal hook must be used under PrescriptionModalProvider',
    );
  }

  return context;
};
